import * as React from "react";
import { SVGProps } from "react";
const SvgPcMac = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29 26H3c-.6 0-1 .4-1 1s.4 1 1 1h26c.6 0 1-.4 1-1s-.4-1-1-1ZM28 3H4c-1.1 0-2 .9-2 2v17c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 19H4V5h24v17Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPcMac;
